const appRoutes = {
    home: {
        root: '/',
        children: {
            productDetails: {
                root: '/product-details',
            },
            statements: {
                root: '/statements',
            },
            propertyValuation: {
                root: '/property-valuation',
            },
        },
    },
    auth: {
        root: ['/auth/*'],
    },
    login: {
        root: '/auth/login',
    },
    register: {
        root: '/auth/register',
    },
    admin: {
        root: '/admin',
    },
    notFound: {
        root: '/*',
    },
};

export default appRoutes;
